// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 1/11/2023
 */

.NavigationButtons_container__rkIiC {
    margin: 0.5rem 0;
}

.NavigationButtons_button__CST3J {
    /* margin-left: 3rem; */
    border-radius: 0.5rem;
    width: 10rem;
    height: 2.5rem;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    padding: 0 2.5rem;
}

.NavigationButtons_buttonContainer__qF2JZ {
    display: flex;
    justify-content: space-between;
    /* justify-content: end; */
}

/* for mobile */
@media (max-width: 770px) {
    .NavigationButtons_buttonContainer__qF2JZ {
        display: flex;
        background-color: #f1e7fd;
        padding: 1rem;
        width: -webkit-fill-available;
        justify-content: space-between;
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 3;
        box-shadow: 0px -4px 5px rgba(89, 124, 215, 0.25);
    }
    .NavigationButtons_button__CST3J {
        margin-left: 0;
        width: 8rem;
        font-size: 1rem;
        padding: 0 1.25rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/NavigationButtons.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA,eAAe;AACf;IACI;QACI,aAAa;QACb,yBAAyB;QACzB,aAAa;QACb,6BAA6B;QAC7B,8BAA8B;QAC9B,eAAe;QACf,SAAS;QACT,QAAQ;QACR,UAAU;QACV,iDAAiD;IACrD;IACA;QACI,cAAc;QACd,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 1/11/2023\r\n */\r\n\r\n.container {\r\n    margin: 0.5rem 0;\r\n}\r\n\r\n.button {\r\n    /* margin-left: 3rem; */\r\n    border-radius: 0.5rem;\r\n    width: 10rem;\r\n    height: 2.5rem;\r\n    font-size: 1.2rem;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0 2.5rem;\r\n}\r\n\r\n.buttonContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    /* justify-content: end; */\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .buttonContainer {\r\n        display: flex;\r\n        background-color: #f1e7fd;\r\n        padding: 1rem;\r\n        width: -webkit-fill-available;\r\n        justify-content: space-between;\r\n        position: fixed;\r\n        bottom: 0;\r\n        right: 0;\r\n        z-index: 3;\r\n        box-shadow: 0px -4px 5px rgba(89, 124, 215, 0.25);\r\n    }\r\n    .button {\r\n        margin-left: 0;\r\n        width: 8rem;\r\n        font-size: 1rem;\r\n        padding: 0 1.25rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NavigationButtons_container__rkIiC`,
	"button": `NavigationButtons_button__CST3J`,
	"buttonContainer": `NavigationButtons_buttonContainer__qF2JZ`
};
export default ___CSS_LOADER_EXPORT___;
